import React from "react";
import { Link } from "react-router-dom";
import abimg from "../../images/about/image-1.jpg";
import sign from "../../images/about/signature.png";

// Define component prop types
interface AboutProps {
  aClass?: string;
}

const About: React.FC<AboutProps> = ({ aClass }) => {
  return (
    <section className={`wpo-about-section ${aClass || ""}`}>
      <div className="container-fluid">
        <div className="wpo-about-wrap">
          <div className="row align-items-center">
            {/* Left Image */}
            <div className="col-xl-3 col-lg-3 col-md-12 col-12">
              <div
                className="wpo-about-img wow fadeInLeftSlow"
                data-wow-duration="1500ms"
              >
                <div className="about-right-img">
                  <img src={abimg} alt="About Bohu Wedding" />
                </div>
              </div>
            </div>

            {/* Text Content */}
            <div className="col-xl-8 col-lg-8 col-md-12 col-12">
              <div
                className="wpo-about-text wow fadeInUp"
                data-wow-duration="1500ms"
              >
                <p>
                  Bohu is a full-service wedding planning agency dedicated to
                  creating unforgettable celebrations that beautifully reflect
                  each couple’s unique love story. From intimate gatherings to
                  grand luxury weddings, we bring together creativity,
                  organization, and passion to design every detail with
                  precision.
                </p>

                <div className="about-info-wrap">
                  <div className="about-info">
                    <h5>Kristin Watson</h5>
                    <span>- CEO of the company</span>
                  </div>
                  <div className="about-sign">
                    <img src={sign} alt="Signature" />
                  </div>
                </div>
              </div>
            </div>

            {/* Social Links */}
            <div className="col-xl-1 col-lg-1 col-md-12 col-12">
              <div
                className="about-social wow fadeInRightSlow"
                data-wow-duration="1500ms"
              >
                <ul>
                  <li>
                    <Link to="/about" aria-label="Facebook">
                      <i className="ti-facebook"></i>
                    </Link>
                  </li>
                  <li>
                    <Link to="/about" aria-label="Twitter">
                      <i className="ti-twitter-alt"></i>
                    </Link>
                  </li>
                  <li>
                    <Link to="/about" aria-label="Instagram">
                      <i className="ti-instagram"></i>
                    </Link>
                  </li>
                  <li>
                    <Link to="/about" aria-label="Pinterest">
                      <i className="ti-pinterest"></i>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
